import React, { useState } from 'react';
import styled from 'styled-components';

interface Props {
  isForm?: boolean;
  onSearch: (term: string) => void;

  input: string;
  setInput: (input: string) => void;
}

function SearchBar({ isForm = false, onSearch, input, setInput }: Props) {
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      onSearch(input);
    }
  };

  return (
    <Container>
      <TextInput
        placeholder={isForm ? '서식 검색' : '경매용어'}
        value={input}
        onChange={(e) => {
          setInput(e.target.value);
        }}
        onKeyDown={handleKeyDown}
      />
      <SearchButton onClick={() => onSearch(input)} isForm={isForm}>
        {isForm ? (
          '검색'
        ) : (
          <img
            src="/assets/images/icon/search_white.svg"
            alt="search"
            width={24}
            height={24}
          />
        )}
      </SearchButton>
    </Container>
  );
}

export default SearchBar;

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 16px;
  min-width: 0;
`;

const TextInput = styled.input`
  flex: 1;
  min-width: 0;
  height: 40px;
  padding: 8px 12px;
  border-radius: 8px;
  border: 1px solid #e1e2e4;
  outline: none;

  font-weight: 500;
  font-size: 16px;
  color: #222222;

  ::placeholder {
    font-weight: 500;
    font-size: 16px;
    color: #37383c9c;
  }
`;

const SearchButton = styled.button<{ isForm: boolean }>`
  padding: ${({ isForm }) => (isForm ? '8px 24px' : '8px')};
  border-radius: 8px;
  background-color: #008aff;
  cursor: pointer;
  border: none;
  white-space: nowrap;
  display: flex;
  align-items: center;

  font-weight: 700;
  font-size: 16px;
  text-align: center;
  color: #ffffff;
`;
